import { FC } from 'react';
import { Select } from 'antd';
import { useLocale } from '@/store';
import { observer } from 'mobx-react';
import './index.less';

const LocaleSelect: FC = observer(() => {
  const [cur, setCur] = useLocale();
  return (
    <Select className='locale-select' defaultValue={cur} onChange={setCur}>
      <Select.Option value='en'>English</Select.Option>
      <Select.Option value='zh'>中文</Select.Option>
    </Select>
  );
});

export default LocaleSelect;
